/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import img1 from "../image/Image _ Page/About_page/Content_1.jpg";
import img2 from "../image/Image _ Page/About_page/Content_2.jpg";
import abo from "../image/Image _ Page/About_page/Chairman_image.jpeg";
import "../Components/style/aboutpage.css";
import AboutSliderPage from "../Components/aboutslider";

const About = () => {
  const styles = {
    page: {
      backgroundColor: "#ffffff",
      fontFamily: "'Arial', sans-serif",
    },
    hero: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "stretch",
      gap: "50px",
      maxWidth: "1180px",
      margin: "0 auto",
      padding: "80px 24px 50px 24px",
    },
    heroLeft: {
      flex: "1 1 420px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "420px",
    },
    heroHeading: {
      fontFamily: "'Lora', serif",
      fontSize: "34px",
      fontWeight: 800,
      color: "#0f1e4d",
      marginBottom: "18px",
      lineHeight: 1.2,
      letterSpacing: "0.5px",
      backgroundColor: "transparent",
      background: "none",
      border: "none",
      boxShadow: "none",
      padding: 0,
      margin: "0 0 18px 0",
    },
    heroText: {
      fontSize: "15px",
      color: "#4b5563",
      lineHeight: 1.8,
      marginBottom: "14px",
    },
    heroTextLabel: {
      fontWeight: 700,
      color: "#0f1e4d",
    },
    heroRight: {
      flex: "1 1 420px",
    },
    heroImage: {
      width: "100%",
      height: "420px",
      objectFit: "cover",
      borderRadius: "0",
    },
    detailsSection: {
      maxWidth: "1180px",
      margin: "0 auto",
      padding: "10px 24px 70px 24px",
    },
    detailsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "28px",
    },
    detailItem: {
      borderLeft: "3px solid #0f1e4d",
      paddingLeft: "18px",
    },
    detailLabel: {
      fontSize: "16px",
      fontWeight: 700,
      color: "#0f1e4d",
      marginBottom: "8px",
    },
    detailText: {
      fontSize: "14.5px",
      color: "#4b5563",
      lineHeight: 1.7,
    },
    missionBox: {
      backgroundColor: "#0f1e4d",
      maxWidth: "1180px",
      margin: "0 auto 90px auto",
      borderRadius: "0",
      padding: "40px",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "30px",
    },
    missionImage: {
      width: "150px",
      height: "150px",
      objectFit: "cover",
      borderRadius: "0",
      flex: "0 0 auto",
    },
    missionTextWrap: {
      flex: "1 1 320px",
    },
    missionHeading: {
      color: "#ffffff",
      fontSize: "22px",
      fontWeight: 800,
      marginBottom: "10px",
    },
    missionText: {
      color: "#dbe4fb",
      fontSize: "14.5px",
      lineHeight: 1.7,
      maxWidth: "700px",
    },
  };

  return (
    <div style={styles.page}>
      {/* Load Lora font for this page */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
      `}</style>

      {/* Hero section — heading + intro text on left (no bg box), image on right, both matched in height */}
      <div style={styles.hero}>
        <div style={styles.heroLeft}>
          <div>
            <h1 style={styles.heroHeading}>THIS IS ORRYX</h1>
            <p style={styles.heroText}>
              Orryx Solution a leading system integration company based in Delhi, India, empowers
              businesses to thrive in the digital age. We specialize in designing, implementing, and
              managing robust IT infrastructure solutions that form the backbone of modern enterprise.
              Our certified engineers and consultants bring deep expertise to critical areas, including
              networking, cybersecurity, data center infrastructure, and more.
            </p>
          </div>
          <p style={styles.heroText}>
            Orryx helps organizations optimize their IT environments to enhance performance, ensure
            business continuity, and maximize IT operational efficiency. We are a technology partner you
            can trust, delivering tailored solutions to specific needs and desired business objectives.
          </p>
        </div>

        <div style={styles.heroRight}>
          <img src={img1} alt="About Orryx" style={styles.heroImage} />
        </div>
      </div>

      {/* Detailed capability breakdown — moved here so the hero above stays image-height */}
      <div style={styles.detailsSection}>
        <div style={styles.detailsGrid}>
          <div style={styles.detailItem}>
            <div style={styles.detailLabel}>Networking</div>
            <p style={styles.detailText}>
              We build and optimize your network infrastructure for seamless connectivity and performance.
            </p>
          </div>
          <div style={styles.detailItem}>
            <div style={styles.detailLabel}>Cybersecurity</div>
            <p style={styles.detailText}>
              We protect your valuable data and systems with cutting-edge cybersecurity solutions,
              mitigating risks and ensuring compliance.
            </p>
          </div>
          <div style={styles.detailItem}>
            <div style={styles.detailLabel}>Data Center Infrastructure</div>
            <p style={styles.detailText}>
              We design, deploy, and manage high-performance data center infrastructure to support your
              business operations.
            </p>
          </div>
          <div style={styles.detailItem}>
            <div style={styles.detailLabel}>Server and Storage Solutions</div>
            <p style={styles.detailText}>
              We provide scalable and reliable server and storage solutions to meet your evolving data
              needs.
            </p>
          </div>
        </div>
      </div>

      {/* Mission box — button removed, sharp corners */}
      <div style={styles.missionBox}>
        <img src={img2} alt="Our Mission" style={styles.missionImage} />
        <div style={styles.missionTextWrap}>
          <h3 style={styles.missionHeading}>Our Mission</h3>
          <p style={styles.missionText}>
            At Orryx, our mission is to empower businesses with robust and innovative system integration
            solutions, fostering efficiency and growth. We deeply understand your unique challenges,
            developing tailored strategies and implementing best-in-class technologies to ensure your
            systems work together harmoniously, achieving your strategic objectives.
          </p>
        </div>
      </div>

      {/* chairman of emicron
      <div className="thot-card">
        <h2 className="thot-title"> Director Desk</h2>

        <div className="chairman-section">
          <div className="chairman-image">
            <img src={abo} alt="Chairman of Emicron" />
          </div>
          <div className="chairman-text"> */}
            {/* <h3>Message from the Chairman</h3> */}
            {/* <p>
              "We believe technology has the power to transform businesses. At Oryyx, we're dedicated to helping our clients harness that power to achieve their goals.  Our focus on innovation, unwavering commitment to excellence, and collaborative teamwork enable us to deliver impactful solutions that make a real difference in the world."
            </p>

            <p><strong><br></br>
              - Rahul Mathur</strong></p>
          </div>
        </div>
      </div>  */}

      {/* Team Cards */}
      {/* <div className="row team-cards-container justify-content-center">
        <div className="team-card col-md-4 col-12 text-center">
          <img className="team-img" src={abo} alt="Amit Lodha" />
          <div className="team-info">
            <h3 className="team-name">Amit Lodha</h3>
            <p className="team-role">Chief Executive Officer</p>
          </div>
        </div>
        <div className="team-card col-md-4 col-12 text-center">
          <img className="team-img" src={abo} alt="Abhishek Gandhi" />
          <div className="team-info">
            <h3 className="team-name">Abhishek Gandhi</h3>
            <p className="team-role">Chief Business Officer</p>
          </div>
        </div>
        <div className="team-card col-md-4 col-12 text-center">
          <img className="team-img" src={abo} alt="Ajit Kumar" />
          <div className="team-info">
            <h3 className="team-name">Ajit Kumar</h3>
            <p className="team-role">Chief Operating Officer</p>
          </div>
        </div>
      </div> */}

      {/* <AboutSliderPage /> */}

    </div>
  );
};

export default About;